import styled from 'styled-components'

const StyledSearch = styled.div`
  position: relative;
  min-width: 24px;
  width: 100%;
  height: 40px;
  display: grid;
  justify-items: flex-end;
  align-items: center;

  & > div {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    opacity: 0;
    visibility: hidden;
  }
  // ICON
  & > div:first-of-type {
    ${props =>
      props.animationState === 'turn-off' || props.animationState === 'set-off'
        ? `
      opacity: 1;
      visibility: visible;
      transition: opacity 0s .4s ease-in-out, visibility 0s .4s ease-in-out, right .5s .4s ease-in-out;
    `
        : `
      right: calc(100% - 35px);
      transition: opacity 0s .5s ease-in-out, visibility 0s .5s ease-in-out, right .5s .2s ease-in-out;
    `}
  }
  // AUTOCOMPLETE
  & > div:last-of-type {
    ${props =>
      props.animationState === 'turn-off' || props.animationState === 'set-off'
        ? `
      transition: opacity 0s .4s ease-in-out, visibility 0s .4s ease-in-out;
    `
        : `
      opacity: 1;
      visibility: visible;
      transition: opacity 0s .5s ease-in-out, visibility 0s .5s ease-in-out;
    `}
  }
`

export default StyledSearch
